import { PremiumRoutes } from "@/premium/routes";
import { EnrollmentContext } from "@/state";
import { keepPreviousData, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AlertProvider } from "capitalrx-components-2.0/lib/general";
import { OverlayContainer } from "capitalrx-components-2.0/lib/general/Overlay";
import { FC, useContext } from "react";
import { ThemeProvider } from "styled-components";

export const PremiumRoot: FC = () => {
  const [state, _] = useContext(EnrollmentContext);
  const theme = state.experienceData.theme;

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AlertProvider>
          <OverlayContainer>
            <PremiumRoutes />
          </OverlayContainer>
        </AlertProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
